module.exports = __webpack_public_path__ + "img/16_118.b59f7ca2.png";